<template>
    <div class="chat-head" :class="{'chat-head--no-sb': isProfile}">
        <div class="chat-head__lesson" v-if="channel || isDashboard || isProfile">
            <div class="component-info">
                <div class="lesson__bg" :class="{'lesson__bg--dashboard': isDashboard}">
                    <img v-if="channel && channel.icon !== null" :src="channel.icon | imgSrc" alt="" width="30px">

                    <img v-else-if="interlocutorPhoto && isChat"
                         :src="interlocutor.photo | imgSrc"
                         alt=""
                         width="30px"
                    >
                    <img v-else-if="isChat && !isDashboard && !isProfile" :src="env.public_base + '/assets/images/person-icon.png'" alt="" width="30px">

                    <img v-if="isDashboard" :src="env.public_base + '/assets/images/chats-icon.svg'" alt="" width="30px">
                    <img v-if="isProfile" :src="env.public_base + '/assets/images/person-icon.svg'" alt="">
                </div>

                    <div class="group-wrap">
                        <h3 v-if="channel && channel.name && isChat">{{ channel.name }}</h3>
                        <h3 v-if="channel && channel.name === '' && isChat || channel && !channel.name && interlocutor && isChat">{{interlocutor.last_name}} {{interlocutor.first_name }} {{teacherPatronymic(interlocutor)}}</h3>

                        <p v-if="$route.name === 'personal-channel' && userData.role === 'teacher' && interlocutorGroup" class="student-groups"><strong>{{ $t("group") }}:</strong> {{ interlocutorGroup }}</p>

                        <div v-if="$route.name === 'personal-channel' && userData.role === 'teacher' && interlocutorVarCourses" class="student-groups">
                            <strong>{{ $t("var_courses_shot") }}:</strong>
                            <div class="tooltip-c">
                                <img
                                    src="/static/front-end/public/assets/images/info-icon.svg"
                                    alt="icon"
                                />
                                <div class="tooltip-c__content">
                                    <span
                                        v-for="label in interlocutorVarCourses"
                                        :key="label"
                                    >
                                        {{ label }}
                                        <br />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <span v-if="channel && channel.is_group === false && channel.is_tech === false && isChat" class="pr-10">{{ studentGroups }}</span>
                    <span v-if="channel && channel.is_group === false && channel.is_tech === false && isChat">{{educationForm }}</span> -->

                    <h3 v-if="isDashboard">{{$t('last_messages')}}</h3>
                    <h3 v-if="isProfile">{{ $t('profile') }}</h3>
            </div>

            <app-moodle-login-form v-if="env.params[userData.school_id].show_moodle"></app-moodle-login-form>
        </div>

        <form v-if="userData.school_id == 2 || userData.school_id == 8" action="https://support.cdo.org.ua/login.php" target="_blank" method="post">
			<input type="hidden" name="moodle_login" :value="userData.moodle_login">
			<input type="hidden" name="moodle_password" :value="userData.moodle_password">
			<input type="hidden" name="login_login">
			<button class="button button--accent button--moodle">Служба підтримки</button>
		</form>
		
		 <a v-if="
        env.params[userData.school_id].show_courses_button
        || (env.params[userData.school_id].show_courses_button_teacher && userData.role == 'teacher')
        || (env.params[userData.school_id].show_courses_button_student && userData.role == 'student')
        || (env.params[userData.school_id].show_courses_button_biller && userData.role == 'biller')
        || (env.params[userData.school_id].show_courses_button_admin && userData.role == 'admin')
        || (env.params[userData.school_id].show_courses_button_moderator && userData.role == 'moderator')
        || (env.params[userData.school_id].show_courses_button_student_billing && userData.role == 'student/billing')"
           href="/courses" class="button button--accent button--moodle button--moodle--center"
        >
            {{ $t('go_to_courses_panel') }}
        </a>

        <button class="search-button" v-if="!isProfile" type="button" @click="showSearch = !showSearch">
            <img v-if="showSearch" :src="env.public_base + '/assets/images/cross-icon--bold-black.svg'" alt="">

            <img v-else :src="env.public_base + '/assets/images/search-icon--black.svg'" alt="">
        </button>

        <div class="sidebar-collapse--chat"
             v-if="techChatsIds && !techChatsIds.some(el => el === channelId) && isChat"
             :class="{'is-active' : sidebarStateRight}"
             @click="toggleSidebarChat"
        >
            <a href="javascript:void(0)" class="sidebar-collapse-icon">

            </a>
        </div>

		<a v-if="
			(env.params[userData.school_id].show_courses_button_teacher && userData.role == 'billing')
        || 	(env.params[userData.school_id].show_courses_button_teacher && userData.role == 'student/billing')"
           href="/payer" class="button button--accent button--moodle button--moodle--center"
        >
            {{ $t('go_to_payer_cabinet') }}
        </a>

        <div class="head-messages" v-if="unreadMessages !== 0 && isDashboard">
            <img :src="env.public_base + '/assets/images/chat-icon--gray.svg'" alt="">
            <p class="messages__text">{{unreadMessages}} {{$t('new_messages')}}</p>
        </div>

        <app-search-form :class="{'is-hidden': !showSearch}" :placeolder="$t('search')" v-if="!isProfile"></app-search-form>

        <Languages
            v-if="isProfile"
            class="header-lang"
        />
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import SearchForm from '../chats/components/SearchForm.vue';
    import env from '../env'
    import MoodleLoginForm from "./MoodleLoginForm";
    import Languages from '../chats/components/Languages';

    export default {
        data: () => ({
            env,
            sidebarChat: false,
            showSearch: true,
        }),
        components: {
            appSearchForm: SearchForm,
            appMoodleLoginForm: MoodleLoginForm,
            Languages,
        },
        computed: {
            ...mapGetters([
                'channel',
                'channelId',
                'sidebarStateRight',
                'userData',
                'techChatsIds',
                'loggedInHash',
                'loggedIn',
                'sidebarStateLeft',
                'dashboard',
                'chatsAll'
            ]),
            currentRouteBase() {
                return location.host === 'demo.sourcelms.com'
            },
            interlocutor() {
                if(!this.channel) return false;
                let interlocutor = this.channel.members.filter(item => item.id !== this.userData.id);
                if(typeof interlocutor !== 'undefined' && interlocutor !== null) {
                    return interlocutor[0]
                }
            },
            interlocutorPhoto() {
                return this.interlocutor && this.interlocutor !== undefined && this.interlocutor.photo !== 'undefined' && this.channel && !this.channel.is_group
            },
			interlocutorUserId() {
                return this.interlocutor && this.interlocutor !== undefined && this.interlocutor.id !== 'undefined' && this.channel && !this.channel.is_group
            },
            interlocutorGroup() {
                if (!this.channel) return null;

                const authors = this.channel.members || [];
                const isIdEqual = (author) => author.id !== this.userData.id;
                const subauthor = authors.find(isIdEqual);

                if (subauthor === undefined) return null;

                const isStudent = ['student', 'student/billing'].includes(subauthor.role);
                
                if (!isStudent) return null;

                const groups = subauthor.students_groups;
                
                if (!groups) return null;

                const groupsNames = groups.map((group) => group.name);
                
                return groupsNames.join(', ') || null;
            },
            interlocutorVarCourses() {
                if (!this.channel) return null;

                const authors = this.channel.members || [];
                const isIdEqual = (author) => author.id !== this.userData.id;
                const subauthor = authors.find(isIdEqual);

                if (subauthor === undefined) return null;

                const isStudent = ['student', 'student/billing'].includes(subauthor.role);
                
                if (!isStudent) return null;

                const courses = subauthor?.var_courses || [];
                
                return courses.length !== 0 ? courses : null;
            },
            studentGroups() {
                let studentsGroups = [],
                    groupsName = [];
                if (this.interlocutor && typeof this.interlocutor !== 'undefined' && typeof this.interlocutor.students_groups !== "undefined" && (this.interlocutor.role === 'student' || this.interlocutor.role === 'student/billing')) {
                    studentsGroups = this.interlocutor.students_groups
                }
                studentsGroups.forEach(group => {
                    groupsName.push(group.name.slice(0, 3))
                });
                return groupsName.join(', ');
            },
            educationForm() {
                if (this.interlocutor && typeof this.interlocutor !== 'undefined' && this.interlocutor.ed_form !== null && typeof this.interlocutor.ed_form !== "undefined" && (this.interlocutor.role === 'student' || this.interlocutor.role === 'student/billing')) {
                    return this.interlocutor.ed_form
                }
            },
            isDashboard() {
                return this.$route.name === 'dashboard'
            },
            isChat() {
                return this.$route.name === 'channel' || this.$route.name === 'personal-channel'
            },
            isProfile() {
                return this.$route.name === 'profile'
            },
            unreadMessages() {
                let result = 0;
                this.dashboard.data.forEach(item => {
                    result += item.unread_messages_count
                });
                return result;
            }
        },

        methods: {
            toggleSidebarChat() {
                this.sidebarChat = !this.sidebarChat;

                this.$store.dispatch('toggleSidebarRight', this.sidebarChat);
            },
            teacherPatronymic(interlocutor) {
                if (interlocutor.role === 'owner' || interlocutor.role === 'teacher' || interlocutor.role === 'admin') {
                    return interlocutor.patronymic
                }
            }
        },
    }
</script>

<style lang="sass">

    .group-wrap
        display: flex
        flex-direction: column


    .header-lang
        position: static
        margin-left: auto

    .pr-10
        margin-right: 10px

    .search-button
        margin-left: auto
        margin-right: 15px
        width: 30px
        height: 30px
        background: transparent

        &:hover
            opacity: 1

        img
            width: 100%
            height: 100%

    .is-hidden
        display: none

    @media screen and (min-width: 768px)
        body
            .search-button
                display: none

    .tooltip-c
        display: inline-flex
        top: 4px

    .tooltip-c .tooltip-c__content
        top: -13px

    .tooltip-c .tooltip-c__content::before,
    .tooltip-c .tooltip-c__content::after
        top: 12px
</style>
